import { helper } from '@ember/component/helper';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

const fieldsRequiredIfNswStaff = [
  'core:firstName',
  'core:lastName',
  'core:emailAddress',
  'core:staffGender',
];

const emailFields = ['core:emailAddress', 'core:studentEmailAddress'];

export default helper(function isFieldRequired([
  jurisdiction,
  emailRequired,
  key,
]) {
  if (
    jurisdiction === Jurisdiction.AU_NSW &&
    fieldsRequiredIfNswStaff.includes(key)
  ) {
    return true;
  }

  if (emailFields.includes(key)) {
    return emailRequired;
  }

  return false;
});
